type StepStatus = 'NOT_STARTED' | 'IN_PROGRESS' | 'COMPLETED' | 'BLOCKED' | 'SKIPPED';

interface StageProgressBarProps {
  steps: Array<{status: StepStatus}>;
}

const statusColors: Record<StepStatus, string> = {
  COMPLETED: 'bg-emerald-500',
  IN_PROGRESS: 'bg-blue-500 animate-pulse',
  BLOCKED: 'bg-red-500',
  SKIPPED: 'bg-gray-300',
  NOT_STARTED: 'bg-gray-200',
};

export function StageProgressBar({steps}: StageProgressBarProps) {
  return (
    <div className='flex gap-px rounded-full overflow-hidden'>
      {steps.map((step, i) => (
        <div key={i} className={`h-2 flex-1 rounded-full ${statusColors[step.status]}`} />
      ))}
    </div>
  );
}
